export default __webpack_public_path__ + "static/media/6.a88cf3d0.png";